import { useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';
import { useTranslation } from 'react-i18next';

import { useGetApiDashboardContrats } from '@/api';
import { assureurs } from '@/constants/grilleAssureursData';
import { useDemoContext } from '@/hooks/DemoContext';
import { filterGestionnairesCatalog } from '@/utils/functions/filterGestionnairesCatalog/filterGestionnairesCatalog';

const usePartnersCatalog = () => {
  const { data, isLoading, isError: isQueryError } = useGetApiDashboardContrats();
  const { isDemo } = useDemoContext();
  const { t } = useTranslation();

  const contrats = (data?.families ?? []).flatMap((famille) => [
    ...(famille.listContrat?.enCours ?? []),
    ...(famille.listContrat?.enTraitement ?? []),
  ]);
  const { gestionnaires, unmatched } = filterGestionnairesCatalog(assureurs, contrats, isDemo, (gestionnaire) =>
    t('autresAcces.gestionnaireCardLabel', { gestionnaire })
  );
  const isError = isQueryError || data?.success === false;

  const unmatchedKey = unmatched.map((contrat) => `${contrat.gestionnaire}|${contrat.gestionnaireAC}`).join(', ');

  useEffect(() => {
    if (!unmatchedKey) return;
    datadogRum.addAction('gestionnaire_absent_du_catalogue', { gestionnaires: unmatchedKey });
  }, [unmatchedKey]);

  return { gestionnaires, isLoading, isError };
};

export { usePartnersCatalog };
